import { CloseCircleFilled } from "@ant-design/icons";
import { Typography } from "antd";
import clsx from "clsx";
import { FC } from "react";

const Error: FC<{
  text?: string;
  size: "fit" | "fill" | "screen";
  iconClassName?: string;
  textClassName?: string;
}> = ({
  text,
  size = "fill",
  iconClassName = "text-gray-800",
  textClassName = "text-gray-800",
}) => {
  return (
    <div
      className={clsx("flex flex-col items-center justify-center  bg-[#f5f5f5]", {
        "w-full h-full": size === "fill",
        "w-fit h-fit": size === "fit",
        "w-screen h-screen": size === "screen",
      })}
    >
      <CloseCircleFilled className={clsx("text-5xl", iconClassName)} />
      {text && (
        <Typography.Title
          style={{ direction: "rtl" }}
          level={5}
          className={clsx("text-center", textClassName)}
        >
          {text}
        </Typography.Title>
      )}
    </div>
  );
};

export default Error;
